var jQuery=$=require('jquery');
    var date = new Date();
    var nowMonth = [date.getFullYear(),date.getMonth()+1];
    module.exports = {
       // props: ['hotelId'],
        data:function(){
            return {
                id:'',
                param:'',
                lock:false,
		        url:this.baseApiPath,
		        user:localStorage['username'],
                currentMonth:nowMonth,
                token:localStorage['token'],
                rooms: [{
                    id: '',
                    hotel: '',
                    name: '标准间',
                    en: '',
                    area: '',
                    floor: '',
                    adult: '',
                    pics:[],
                    child: '',
                    bed: '',
                    smoke: 1,
                    pet: 0,
                    addbe: 1,
                    updatetime:'',
                    intro:''
                }]
            }
        },
        //计算属性
        computed: {
        	
        },
        ready:function(){
            this.param=this.$route.params.id;
            if(this.param){
                this.id = this.param;
                var data = {
                    method: 'room_load',
                    token: localStorage['token'],
                    hotel: this.param - 0
                }
                
                var jqPromise = $.post(this.url, data);
                var realPromise = Promise.resolve(jqPromise),
                    that = this;
                realPromise.then(function(value){
                      var value = JSON.parse(value)
                      return value;
                })
               .then(function(value) {
                    
                    if(value.data&&value.data.rooms.length!=0){
                        that.rooms =value.data.rooms;
                    }else{
                        that.rooms = [{
                            id: '',
                            hotel: '',
                            name: '',
                            en: '',
                            area: '',
                            pics:[],
                            floor: '',
                            adult: '',
                            child: '',
                            bed: '',
                            smoke: 0,
                            pet: 0,
                            addbe: 0,
                            updatetime: ''
                        }];
                    }
                    return value;
                })
            }    
        },
        attached:function(){
            var that = this
            $(".calendar .title .next, .calendar .title .prev").unbind("click").click(function(){
                
                if( this.lock === true ) return;

                if ($(this).is(".next")){
                    that.currentMonth = getDate(that.currentMonth,0);
                }else {
                    that.currentMonth = getDate(that.currentMonth,2);
                }

                that.updateCalendar();
            });

            $(".calendar .week").on('click','span',function(){
                var w = $(this);
                var i = w.prevAll("span").length;
                if (i == 0) i = 7;
                if (w.is(".freeze")) {
                    $(".calendar .date .w"+i).removeClass("freeze");
                    w.removeClass("freeze");
                    w.children("b").removeClass("fa-square-o").addClass("fa-check-square-o");
                } else {
                    $(".calendar .date .w"+i).addClass("freeze");
                    w.addClass("freeze");
                    w.children("b").removeClass("fa-check-square-o").addClass("fa-square-o");
                }
            });

            $("input[name=quick_select]").unbind("click").click(function(){

                var type = $(this).val();

                var selected = false;

                if( $(this).is(':checked') ) {
                    selected = true;
                }

                switch(type){
                    case '1':
                       var obj = $("#calendar li.w1:not('.disabled,.opacity'),#calendar li.w2:not('.disabled,.opacity'),#calendar li.w3:not('.disabled,.opacity'),#calendar li.w4:not('.disabled,.opacity')");
                       break;
                    case '2':
                        var obj = $("#calendar li.w5:not('.disabled,.opacity')");
                        break;
                    case '3':
                        var obj = $("#calendar li.w6:not('.disabled,.opacity'),#calendar li.w7:not('.disabled,.opacity')");
                        break;
                }
                if ( selected ){ 
                    obj.addClass("selected");
                } else {
                    obj.removeClass("selected");
                }
            });

            $("#set").unbind("click").click(function(){
                var i = -1;
                var allot = $("#date-allot").val();

                if( allot == "" ) {
                    alert("请先设置库存");
                    return false;
                }

                allot = parseInt(allot, 10);

                if ( isNaN(allot) ) {
                    alert("库存设置不正确");
                    return false;
                }

                $(".calendar .date .selected:not(.freeze)").each(function(){

                    var li = $(this);

                    var span = li.children("span");
                    
                    li.children("input:eq(0)").val(allot);
                    
                    span.html(allot).show();

                    li.removeClass("allot request filled");

                    span.removeClass("label-success label-warning label-danger");
                    
                    li.addClass("allot");

                    span.addClass("label-success");
                });

            });

            $("#set2").unbind("click").click(function(){
                $(".calendar .date .selected:not(.freeze)").each(function(){
                    var li = $(this);
                    li.removeClass("allot request").addClass("filled");
                    li.children("span").html('满房').show();
                    li.children("span").removeClass("label-success label-warning").addClass("label-danger");
                    li.children("input:eq(0)").val(-1);
                });
            });

            $("#calendar").on('click','li',function(e){
                var li = $(this);
                if (li.is(".disabled")) return;
                if (li.is(".selected")) {
                    li.removeClass("selected");
                    var type = "remove";
                } else {
                    li.addClass("selected");
                    var type = "add";
                }
                if (e.shiftKey) {
                    var list = $(".calendar .date li");
                    var start = $(".calendar .date .start");
                    if (start.length) {
                        var s = list.index(start.eq(0));
                        var e = list.index(li);
                        var li = (s <= e) ? list.slice(s, e) : list.slice(e, s);
                        if (type == "add") li.addClass("selected");
                        else li.removeClass("selected");
                        start.removeClass("start");
                        li.focus().addClass("start");
                    }
                } else {
                    $(".calendar .date .start").removeClass("start");
                    li.addClass("start");
                }
            });

        },
        methods: {
            updateCalendar:function(){

                var room = $("select[name=room_size]").val();
                
                if( !room ) {
                    
                    alert('请选择房型')

                    return
                }

                $("#room_id").val(room);

                var data = {
                    method: 'amenserv_bookingstock',
                    token: localStorage['token'],
                    id: room,
                    month:this.currentMonth[0]+'-'+this.currentMonth[1]
                }
                
                var jqPromise = $.post(this.url, data);
                var realPromise = Promise.resolve(jqPromise),
                    that = this;
                that.lock = true;
                realPromise.then(function(value){
                      var value = JSON.parse(value)
                      if(value.data && value.data.stock){
                        $("#calendar").html(value.data.stock)
                        that.lock = false;
                      }
                })

            },
            calendar_save:function(){
                var data = $("#form").serialize();
                var jqPromise = $.post(this.url, data);
                var realPromise = Promise.resolve(jqPromise),
                    that = this;
                realPromise.then(function(value){
                      var value = JSON.parse(value)
                      if(value.code==0){
                        alert("设置成功");
                      }else{      
                        alert(value.message)
                    }
                })
            },
            calendar_cancel:function(){
                $("#date-price,#date-allot,#date-bprice").val('');
            },
        },
        route:{
            data: function(transition) {
                if (this.param) {
                    this.param=this.id=this.$route.params.id;
                    var data = {
                        method: 'room_load',
                        token: localStorage['token'],
                        hotel: this.param - 0
                    }
                    var jqPromise = $.post(this.url, data);
                    var realPromise = Promise.resolve(jqPromise);
                    var that = this;
                    realPromise.then(function(value){
                            var value = JSON.parse(value)

                            var options = '<option value=""></option>';

                            if(value.data&&value.data.rooms.length!=0){
                                $.each(value.data.rooms,function(k,v){
                                    options +='<option value="'+v.id+'">'+v.name+'</option>';
                                });
                            }
                            
                            $("select[name=room_size]").html(options);
                         
                           return value;
                    })

                }
            },
        }
    }

    var getDate = function(arr,decr) {
        var temp = new Date();
        temp.setFullYear(parseInt(arr[0],10), parseInt(arr[1],10) - parseInt(decr), 10);
        temp.setHours(0,0,0,0);
        return [temp.getFullYear(),temp.getMonth()+1] ;
    };


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/stock.vue
// module id = 109
// module chunks = 0